import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CalendarGroupItemService } from 'app/services/calendar-group-item/calendar-group-item.service';
import { CalendarService } from 'app/services/calendar/calendar.service';
import { Observable } from 'rxjs/Observable';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'calendar-group-item-form',
  templateUrl: 'form-calendar-group-item.html',
  styles: ['label.required:after {top: 0}']
})

export class CalendarGroupItemComponent implements OnInit {
  @Output() calendarGroupItemAdded: EventEmitter<any> = new EventEmitter<any>();
  @Input() calendarGroupId: any;

  form: FormGroup;
  fields: any;
  public invalidSubmit: boolean;
  calendarItems: Array<{value: string, label: string}> = [{value: null, label: ''}]

  constructor(
    private fb: FormBuilder,
    private srvCalendarGroupItem: CalendarGroupItemService,
    private srvCalendarItems: CalendarService
    ) {}

  ngOnInit(): void {

    this.srvCalendarGroupItem.getFields().subscribe(res => {
      this.fields = res;
    });

    let calendarItemsCall: Observable<any> = this.srvCalendarItems.getAll();
    Observable.zip(calendarItemsCall)
    .subscribe(([calendarItems]) => {

      for (const item of calendarItems) {
        this.calendarItems.push({
          label: `${item.code} - ${item.description}`,
          value: item.id
        });
      }
      this.form = this.fb.group({
        'calendar_item_id': new FormControl(null)
      });
    });
  }

  save() {
    if (!this.form.value.calendar_item_id) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    const groupItem = {
      calendar_group_id: +this.calendarGroupId,
      calendar_item_id: +this.form.value.calendar_item_id
    };

    this.srvCalendarGroupItem.post(groupItem).subscribe( () => {
      this.calendarGroupItemAdded.emit(groupItem);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/calendar-group/form-calendar-group/form-calendar-group-item.ts